/*
 *
 * EasySplitSettlements constants
 *
 */
export const BASE_ACTION_CONSTANT = 'app/EasySplitPayments';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const GET_TRANSFER_BALANCE = `${BASE_ACTION_CONSTANT}/GET_TRANSFER_BALANCE`;

export const GET_TRANSFER_CHARGES = `${BASE_ACTION_CONSTANT}/GET_TRANSFER_CHARGES`;

export const GET_ON_DEMAND_TABLE_DATA = `${BASE_ACTION_CONSTANT}/GET_ON_DEMAND_TABLE_DATA`;

export const GET_SCHEDULED_TABLE_DATA = `${BASE_ACTION_CONSTANT}/GET_SCHEDULED_TABLE_DATA`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const GENERATE_SETTLEMENT_REPORT = `${BASE_ACTION_CONSTANT}/GENERATE_SETTLEMENT_REPORT`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/EABLE_LOADER`;

export const CREATE_VENDOR_BALANCE_TRANSFER = `${BASE_ACTION_CONSTANT}/CREATE_VENDOR_BALANCE_TRANSFER`;

export const SAVE_TRANSFER_BALANCE_SUCCESS = `${BASE_ACTION_CONSTANT}/SAVE_TRANSFER_BALANCE_SUCCESS`;

export const SAVE_LIVE_SETTLEMENT = `${BASE_ACTION_CONSTANT}/SAVE_LIVE_SETTLEMENT`;

export const FETCH_LIVE_SETTLEMENT = `${BASE_ACTION_CONSTANT}/FETCH_LIVE_SETTLEMENT`;

export const GET_SETTLEMENT_TIMELINE = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_TIMELINE`;

export const SEARCH_VENDOR_SETTLEMENTS_TIMELINE_URL = {
  url: '/pg/settlements/split/vendor-settlement/search',
  method: 'GET',
};

export const GET_TRANSFER_BALANCE_URL = {
  url:
    '/pg/settlements/split/merchants/$merchantId$/vendors/$vendorId$/balances',
  method: 'GET',
};

export const GET_TRANSFER_CHARGES_URL = {
  url: '/pg/settlements/split/merchants/$merchantId$/amount/$amount$/charges',
  method: 'GET',
};

export const GET_ON_DEMAND_TABLE_DATA_URL = {
  url: '/pg/settlements/on/demand/table/data',
  method: 'GET',
};

export const GET_SCHEDULED_TABLE_DATA_URL = {
  url: '/pg/settlements/split/extended-payouts/search',
  method: 'GET',
};

export const CREATE_VENDOR_BALANCE_TRANSFER_URL = {
  url:
    '/pg/settlements/split/merchants/$merchantId$/vendors/$vendorId$/transfer',
  method: 'POST',
};

export const HEADINGS = {
  Scheduled: [
    {
      key: 'addedOn',
      displayName: 'Date & Time',
      width: 0.15,
    },
    {
      key: 'period',
      displayName: 'Period',
      width: 0.11,
    },
    {
      key: 'settlementType',
      displayName: 'Type',
      width: 0.08,
    },
    {
      key: 'merchantVendorId',
      displayName: 'Vendor ID',
      width: 0.12,
    },
    {
      key: 'payoutId',
      displayName: 'Settlement ID',
      width: 0.12,
    },
    {
      key: 'utr',
      displayName: 'UTR No.',
      width: 0.12,
    },
    {
      key: 'adjustmentAmount',
      displayName: 'Adjustment Amt.',
      width: 0.14,
      align: 'right',
    },
    {
      key: 'settledAmount',
      displayName: 'Settled Amt.',
      width: 0.12,
      align: 'right',
    },
    {
      key: 'status',
      displayName: 'Status',
      width: 0.12,
    },
    {
      key: 'failureReason',
      displayName: 'Failure Reason',
      width: 0.13,
    },
    {
      key: 'settlementLinkCTA',
      displayName: '',
      width: 0.06,
    },
  ],
  'On-Demand': [
    {
      key: 'initiatedAt',
      displayName: 'Initiated At',
      width: 0.06,
    },
    {
      key: 'vendorId',
      displayName: 'Vendor ID',
      width: 0.04,
    },
    {
      key: 'vendorName',
      displayName: 'Vendor Name',
      width: 0.07,
    },
    {
      key: 'debitedFrom',
      displayName: 'Debited From',
      width: 0.06,
    },
    {
      key: 'settlementId',
      displayName: 'Settlement ID',
      width: 0.05,
    },
    {
      key: 'utr',
      displayName: 'Utr No.',
      width: 0.06,
    },
    {
      key: 'charges',
      displayName: 'Charges',
      width: 0.04,
    },
    {
      key: 'settlementAmt',
      displayName: 'Settlement Amount',
      width: 0.06,
      align: 'right',
    },
  ],
  VENDOR_FOR_SETTLEMENT_V2_UI: [
    {
      key: 'settlementTypeCTA',
      displayName: '',
      width: 0.04,
    },
    {
      key: 'addedOn',
      displayName: 'Initiated At',
      tooltip: 'Initiated At',
      width: 0.14,
    },
    {
      key: 'merchantVendorId',
      displayName: 'Vendor ID',
      tooltip: 'Vendor ID',
      width: 0.12,
    },
    {
      key: 'payoutId',
      displayName: 'Settlement ID',
      width: 0.1,
    },
    {
      key: 'utr',
      displayName: 'UTR',
      width: 0.14,
    },
    {
      key: 'settledAmount',
      displayName: 'Settled Amt.',
      width: 0.1,
    },
    {
      key: 'settlementStatus',
      displayName: 'Status',
      width: 0.3,
    },
  ],
};

export const ON_DEMAND_TRANSFER_SUCCESS_MAPPING = {
  initiatedAt: 'Initiated At',
  additionalCharges: 'Addl. Charges',
  amount: 'Settled Amt.',
};

export const DEBITED_FROM_MAPPING = {
  MERCHANT: ['MERCHANT_ON_DEMAND'],
  VENDOR: ['VENDOR_ON_DEMAND'],
};

export const DEBITED_TABLE_MAPPING = {
  MERCHANT_ON_DEMAND: 'Merchant',
  VENDOR_ON_DEMAND: 'Vendor',
};

export const VENDOR_SETTLEMENT_STATUS_TYPES = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REVERSED: 'REVERSED',
  CREATED: 'CREATED',
};

export const BREAKDOWN_EVENT = {
  PG_TAXES_CHARGES: 'PG (Charges+Taxes)',
  SETTLEMENT_TAXES_CHARGES: 'Settlement (Charges+Taxes)',
  SPLIT_TAXES_CHARGES: 'Split (Charges+Taxes)',
};

export const SETTLEMENT_TIMELINE = {
  YOUR_BANK: {
    label: 'Your Bank',
    largeLabel: 'Your Bank Account',
  },
  INITIATED_BY_BANK: {
    label: 'Partner Bank',
    largeLabel: 'Initiated by Partner Bank',
  },
  INITIATED_BY_CASHFREE: {
    label: 'Cashfree',
    largeLabel: 'Initiated by Cashfree Payments',
  },
  RETRY: {
    type: 'trial',
  },
};
